// Named authors for the Ransen blog — powers E-E-A-T (Experience, Expertise,
// Authoritativeness, Trust) signals for Google and drives Person + author
// schema for LLM citation attribution.

export const AUTHORS = [
  {
    slug: 'ransen-team',
    name: 'Ransen Team',
    title: 'Growth Editorial Team',
    bio: 'The Ransen Team is a collective of senior strategists, media buyers, SEO leads, and data engineers publishing research and playbooks from live client programs across ecommerce, SaaS, healthcare, real estate, and B2B categories.',
    avatar: 'https://ransen.io/favicon.png',
    linkedin: 'https://www.linkedin.com/company/ransen',
    twitter: 'https://twitter.com/ransen',
    expertise: ['Digital Marketing', 'SEO', 'LLMO', 'Paid Media', 'Attribution'],
    experienceYears: 8,
  },
  {
    slug: 'jordan-park',
    name: 'Jordan Park',
    title: 'Head of Paid Media',
    bio: 'Jordan leads paid media at Ransen. Twelve years running performance programs across Meta, Google, TikTok, and LinkedIn for ecommerce and B2B SaaS. Previously ran growth at two Series B startups. Meta Blueprint and Google Ads certified.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80',
    linkedin: 'https://www.linkedin.com/in/ransen',
    twitter: 'https://twitter.com/ransen',
    expertise: ['Meta Ads', 'Google Ads', 'TikTok Ads', 'Advantage+', 'Performance Max'],
    experienceYears: 12,
  },
  {
    slug: 'priya-krishnan',
    name: 'Priya Krishnan',
    title: 'Head of SEO & LLMO',
    bio: 'Priya heads SEO and LLM Optimization at Ransen. Ten years building content and technical SEO programs, most recently focused on entity SEO and LLM citation strategy across ChatGPT, Claude, Gemini, and Perplexity.',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80',
    linkedin: 'https://www.linkedin.com/in/ransen',
    twitter: 'https://twitter.com/ransen',
    expertise: ['SEO', 'LLMO', 'AEO', 'Entity SEO', 'Programmatic SEO', 'Content Strategy'],
    experienceYears: 10,
  },
  {
    slug: 'marcus-chen',
    name: 'Marcus Chen',
    title: 'Head of Analytics & Attribution',
    bio: 'Marcus leads analytics and attribution engineering at Ransen. Nine years building server-side tracking, warehouse-native analytics, marketing mix models, and incrementality programs for mid-market and enterprise brands.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80',
    linkedin: 'https://www.linkedin.com/in/ransen',
    twitter: 'https://twitter.com/ransen',
    expertise: ['GA4', 'Server-Side Tracking', 'CAPI', 'MMM', 'Incrementality', 'BigQuery'],
    experienceYears: 9,
  },
];

// Map blog-post slug → author slug. Any post not listed here defaults to 'ransen-team'.
export const POST_AUTHORS = {
  'llm-optimization-guide-2025': 'priya-krishnan',
  'seo-content-strategy-ai-era': 'priya-krishnan',
  'aeo-answer-engine-optimization': 'priya-krishnan',
  'programmatic-seo-when-it-works': 'priya-krishnan',
  'server-side-tracking-google-cloud-playbook': 'marcus-chen',
  'attribution-modeling-2026': 'marcus-chen',
  'meta-advantage-plus-vs-manual-2025': 'jordan-park',
  'google-ads-performance-max-2026': 'jordan-park',
  'linkedin-ads-b2b-playbook-2026': 'jordan-park',
  'tiktok-ads-2026-guide': 'jordan-park',
  'creative-testing-framework-meta': 'jordan-park',
  'ai-agents-marketing-operations': 'ransen-team',
  'cro-conversion-rate-optimization-2026': 'ransen-team',
};

export function getAuthor(slug) {
  return AUTHORS.find((a) => a.slug === slug) || AUTHORS[0];
}

export function getAuthorForPost(postSlug) {
  return getAuthor(POST_AUTHORS[postSlug] || 'ransen-team');
}
